import React, { Component } from 'react';
import { Form, Input, Button, Icon } from 'antd';

class LoginForm extends Component {
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((error, values) => {
            if(error) return console.error('Received values of form: ', values);
            if(values.username && values.password) {
                this.props.onSubmit && this.props.onSubmit(values);
            }
        });
    }

    render() {
        const { loading, defaults = { username: '', password: '' } } = this.props;
        const { getFieldDecorator } = this.props.form;

        return <Form onSubmit={this.handleSubmit}>
            <Form.Item>
                {getFieldDecorator('username', {
                    initialValue: defaults.username
                })(
                    <Input prefix={<Icon type={'user'} style={{ color: 'rgba(0,0,0,.25)' }} />} 
                        placeholder={'Пользователь'} disabled={loading} />
                )}
            </Form.Item>
            <Form.Item>
                {getFieldDecorator('password', {
                    initialValue: defaults.password
                })(
                    <Input prefix={<Icon type={'lock'} style={{ color: 'rgba(0,0,0,.25)' }} />} 
                        type={'password'} placeholder={'Пароль'} disabled={loading} />
                )}
            </Form.Item>
            <Form.Item style={{ marginTop: 20 }}>
                <Button
                    loading={loading}
                    style={{ width: '100%' }}
                    size={'large'} 
                    type={'primary'} 
                    htmlType={'submit'}
                >{ !loading && 'Войти' }</Button>
            </Form.Item>          
        </Form>
    }
}

export default Form.create()(LoginForm);


// WEBPACK FOOTER //
// ./src/components/LoginForm.jsx